export default __webpack_public_path__ + "static/media/expOrange.9383b2df.svg";